<!-- begin:: Brand -->
<div class="kt-aside__brand kt-grid__item  " id="kt_aside_brand">
	<div class="kt-aside__brand-logo">
		<a routerLink="/">
			<img alt="logo" [attr.src]="headerLogo" />
		</a>
	</div>
</div>
<!-- end:: Brand -->
